
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB7UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/0WC/4+0/5u8/2mb/4Os//L3/////83e/1GL/8DV /12T/2qb/83d/3aj/1GK/6jF/+bv/4Ks/4Kr/8HV/+bu/wAAAOfvZO4AAAASdFJOUwBAj9/PnyAQ kI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH 5wwEAzkjI6K5XQAAANBJREFUKM990ssCgiAQBdCJUrOXNYg6WNHD6v//MBQLIeiulOMsuA6AzozN 0ckiScEkW2IgeTbYAoNZ9brESHKAFKNZQxJHBhv7wktRTXEO9rluiEjyiVpseyMSQawHoyaIwiC1 RylPPp6NKa6UuviIcsAKWyGuP8hvd1L6Lh3R4wftV5/bflE3YFLhk0oX64Y+kaczd7C1NukBnAa8 HsBtwMTDbmqvL46r1QmbsQLcwi7+sxNYx1GvZ3SU6e0r/q0mFMFZlo07nybe9J4d+vM3nhA3xPH3 DFUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTIrMDA6MDBWeKhCAAAAJXRF WHRkYXRlOm1vZGlmeQAyMDIzLTEyLTA0VDAyOjMyOjEyKzAwOjAwJyUQ/gAAACh0RVh0ZGF0ZTp0 aW1lc3RhbXAAMjAyMy0xMi0wNFQwMzo1NzozNSswMDowMCS40FAAAAAASUVORK5CYII="}})])
          )
        }
      }
    